import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, delay, finalize } from 'rxjs/operators';
import { LoadModalComponent } from '../load-modal/load-modal.component';
import { ExceptionHttp } from '../exception-http';
import { SesionService, paths } from './sesion.service';
import { Router } from '@angular/router';
import { LanguageService } from './language.service';





@Injectable()
export class HttpInterceptorService implements HttpInterceptor {

  private get initializedResources$() {
    return this.langService.translationsLoaded;
  }

  //private initializedResources = new EventEmitter();
  constructor(private sesion: SesionService, private router: Router, private langService: LanguageService) {
    //console.log('HttpInterceptorService');

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const dupReq = request.clone({ headers: request.headers.set('cultura', this.sesion.idioma$.getValue()) });

    return next.handle(dupReq).pipe(
      delay(10),
      catchError(respuestaError => {
        return new Observable<HttpEvent<any>>(observador => {
          const subscription = this.initializedResources$.subscribe(async inicializados => {
            if (inicializados) {
              let dtoError;
              let message: string = '';
              try {
                this.sesion.fechaFinMantenimiento = null;
                if (typeof respuestaError == 'string') {
                  message = respuestaError;
                } else {
                  const httpErrorResponse = (respuestaError as HttpErrorResponse)
                  if (httpErrorResponse) {
                    if (httpErrorResponse.status == 503) {
                      if (httpErrorResponse.headers.has('Retry-After')) {
                        console.log("httpErrorResponse.headers['Retry-After']", httpErrorResponse.headers.get('Retry-After'))
                        this.sesion.fechaFinMantenimiento = new Date(httpErrorResponse.headers.get('Retry-After'));
                        console.log('this.sesion.fechaFinMantenimiento', this.sesion.fechaFinMantenimiento.toString());
                        await this.router.navigate([paths.offline[this.sesion.idioma$.getValue()]]);
                      }
                    } else if (httpErrorResponse.status != 500 && httpErrorResponse.status != 0) {
                      dtoError = httpErrorResponse.error;
                      message = this.mensajeError(dtoError);
                    }
                  }
                }
              } catch (e) {
              }

              if (message == '') {
                message = this.langService.instant('Shared.GenericError');
              }
              const exception = new ExceptionHttp(message, respuestaError.status, dtoError);
              observador.error(exception);
            }
          })
        });
      }));
  }

  private mensajeError(dtoError: any): string {
    //console.log(dtoError);
    let message: string = '';
    if (dtoError instanceof Array) {
      dtoError.forEach(dtoError => {
        message = message + this.mensajeError(dtoError) + '\n';
      });
    } else {
      if (dtoError?.Message && dtoError?.Message !== '') {
        message = dtoError.Message;
      } else {
        message = this.langService.instant('Shared.GenericError');
      }
    }
    return message;
  }
}
